// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-module--footer--1BnAB","content":"styles-module--content--2AAxL","subfooter":"styles-module--subfooter--10UnV","copyright":"styles-module--copyright--LEemq"};